var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_1802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 0H42.6676V32H0.000976562V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00098 0L21.2676 12.0667L37.4676 0H42.6676V4.13333L26.6676 16.0667L42.6676 27.9333V32H37.3343L21.3343 20.0667L5.40098 32H0.000976562V28L15.9343 16.1333L0.000976562 4.26667V0H5.00098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2676 18.7333L42.6676 29.3333V32L24.601 18.7333H28.2676ZM16.001 20.0667L16.401 22.4L3.60098 32H0.000976562L16.001 20.0667ZM42.6676 0V0.2L26.0676 12.7333L26.201 9.8L39.3343 0H42.6676ZM0.000976562 0L15.9343 11.7333H11.9343L0.000976562 2.8V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0676 0V32H26.7343V0H16.0676ZM0.000976562 10.6667V21.3333H42.6676V10.6667H0.000976562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 12.8667V19.2667H42.6676V12.8667H0.000976562ZM18.201 0V32H24.601V0H18.201Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_1802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6667,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.44dd87629c4ca3332d0e2cca198efdaa.svg";
export { ForwardRef as ReactComponent };